import { Button, Col, Row } from "reactstrap";
import { useEffect, useState } from "react";

import { ImageFieldPresentation } from "../RecordNameCell";
import ReferenceTooltip from "./ReferenceTooltip";
import StrUtils from "../../../utils/StrUtils";

interface MultiReferenceTooltipProps {
  records: Record<string, any>[];
  startingIndex?: number;
  onView: () => void;
  imageField?: string;
  imageFieldPresentation?: ImageFieldPresentation;
}

const MultiReferenceTooltip = ({
  records,
  startingIndex = 0,
  onView,
  imageField,
  imageFieldPresentation,
}: MultiReferenceTooltipProps) => {
  const [page, setPage] = useState(0);

  const switchPage = (newPage: number) => {
    if (newPage < 0) return setPage(records.length - 1);
    if (newPage >= records.length) return setPage(0);

    setPage(newPage);
  };

  useEffect(() => {
    setPage(startingIndex);
  }, [startingIndex]);

  return (
    <div style={{ width: "100%" }}>
      <ReferenceTooltip
        record={records?.length ? records[page] : {}}
        onView={onView}
        imageField={imageField}
        imageFieldPresentation={imageFieldPresentation}
      />

      <div className="border-top border-superlight px-2 py-2">
        <Row className="align-items-center">
          <Col xs="auto">
            <Button
              size="sm"
              color="secondary"
              outline
              className="btn-icon-only "
              style={{ height: 25, width: 25 }}
              onClick={(e) => {
                e.stopPropagation();
                switchPage(page - 1);
              }}
            >
              <i
                className="mdi mdi-chevron-left"
                style={{
                  fontSize: 23,
                  lineHeight: 1,
                  position: "relative",
                  top: 1,
                }}
              />
            </Button>
          </Col>
          <Col>
            <div className="text-center">
              <small style={{ fontSize: 12 }} className="font-weight-500">
                {StrUtils.formatNumber(page + 1)} of{" "}
                {StrUtils.formatNumber(records?.length)}
              </small>
            </div>
          </Col>
          <Col xs="auto">
            <Button
              size="sm"
              color="secondary"
              outline
              className="btn-icon-only"
              style={{ height: 25, width: 25 }}
              onClick={(e) => {
                e.stopPropagation();
                switchPage(page + 1);
              }}
            >
              <i
                className="mdi mdi-chevron-right"
                style={{
                  fontSize: 23,
                  lineHeight: 1,
                  position: "relative",
                  top: 1,
                }}
              />
            </Button>
          </Col>
        </Row>
      </div>
    </div>
  );
};

export default MultiReferenceTooltip;
